import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_entity_branch_group_hdr_RowClass } from '../../dbschema/bl_fi_mst_entity_branch_group_hdr.model';

export class EntityBranchGroupHdrContainerModel extends BaseContainerModel{
    bl_fi_mst_entity_branch_group_hdr: bl_fi_mst_entity_branch_group_hdr_RowClass = new bl_fi_mst_entity_branch_group_hdr_RowClass();   
}
